import { TimeAgo } from '@/components/shared/timeAgo/TimeAgo';
import useTenantState from '@/states/tenant.state';
import { INotificationData } from '@/utils/types/notification';
import { Link } from 'react-router-dom';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const NotificationContent = ({ notifications }: any) => {
  const { currentTenant } = useTenantState();
  return (
    <div className="p-3 -ml-5 md:-ml-40 bg-white rounded-xl w-96 shadow-xl">
      <div className="m-3 text-xs text-end">
        <Link className="text-primary text-end" to={'#'} onClick={() => undefined}>
          Mark All as Read
        </Link>
      </div>
      <div className="flex-col mx-3 mb-3 max-h-96 overflow-auto">
        {notifications ? (
          notifications.slice(0).map((notification: INotificationData) => (
            <button key={notification.id} className="text-left w-full">
              <div className="relative w-full max-w-lg p-4 mb-1 border border-gray-300 rounded-md">
                {!notification.isRead && (
                  <span className="absolute top-0 right-0 mt-2 mr-2 text-4xl text-red-500">•</span>
                )}
                <p className="text-md font-semibold">{notification.subject}</p>
                <p className="mt-2 text-xs">{notification.content}</p>
                <TimeAgo timestamp={notification.createdDate} />
              </div>
            </button>
          ))
        ) : (
          <div className="py-6">
            <p className="text-center text-sm text-slate-500">No notifications</p>
          </div>
        )}
      </div>
      <div className="text-center text-md">
        <Link to={`/${currentTenant?.slug}/notifications`} className="text-primary text-end">
          See all notifications
        </Link>
      </div>
    </div>
  );
};
